import { makeStyles, Grid } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import SWLink from '../_components/SWLink'
import ContentFeature from '../_components/ContentFeature'

const useStyles = makeStyles<Theme, FinestWhitesNeutralsProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'FinestWhitesNeutrals' }
)

export interface FinestWhitesNeutralsProps {
  classes?: StyleClasses<typeof useStyles>
}

function FinestWhitesNeutrals(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <ContentFeature
        title={
          <>
            Our Brightest Whites <br />& Neutrals
          </>
        }
        description={
          <>
            An incredibly versatile range <br />
            of whites and neutrals from <br />
            our experts to suit any style.
          </>
        }
        cta={
          <>
            <Grid item lg={6} md={6} xs={6}>
              <SWLink
                href="https://www.sherwin-williams.com/en-us/color/color-family/white-paint-colors?utm_medium=referral&utm_source=paintscout&utm_campaign=digall-2026&utm_content=color-family-white"
                label="WHITES"
                theme="dark"
                style={{ width: '100%' }}
              />
            </Grid>
            <Grid item lg={6} md={6} xs={6}>
              <SWLink
                href="https://www.sherwin-williams.com/en-us/color/color-collections/finest-whites-neutrals?utm_medium=referral&utm_source=paintscout&utm_campaign=digall-2026&utm_content=color-family-neutrals"
                label="NEUTRALS"
                theme="dark"
                style={{ width: '100%' }}
              />
            </Grid>
          </>
        }
        colorTileA={{
          color: '#ccccc4',
          colorCode: '9548',
          colorName: 'Sweater Weather',
          darkText: true
        }}
        colorTileB={{
          color: '#eeefe9',
          colorCode: '7006',
          colorName: 'Extra White',
          darkText: true
        }}
        image={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/our-finest-whites-and-neutrals.png'}
        imageAlt="Sherwin-Williams finest whites and neutrals collection"
        reverseOrder
      />
    </div>
  )
}

export default FinestWhitesNeutrals
